import { Button, Card, Col, Row, Table } from 'react-bootstrap'
import Pagination from '../../ui/Pagination/Pagination'
import { useTranslation } from 'react-i18next'
import SearchFilters from '../../ui/filter/SearchFilters'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { DefaultParams, PAGESIZE } from '../../utils/constants'
import { useGetChallengesQuery } from '../../store/api/chellenge/chellenge'
import Loading from '../Loading/Loading'
import ChallengesTable from './ChallengesTable'
import { useEffect } from 'react'
import { searchParamsData } from '../../utils/searchParamsData'

const Challenges = (): JSX.Element => {
  const { t: tGeneral } = useTranslation('general')
  const { t: tSideBar } = useTranslation('sideBar')
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const {
    isLoading,
    data: challenges,
    refetch
  } = useGetChallengesQuery(searchParamsData(searchParams, { ...DefaultParams }))

  useEffect(() => {
    refetch()
  }, [])

  return (
    <div>
      {isLoading ? <Loading /> : null}
      <Row className='mt-5 mb-5'>
        <SearchFilters setQuery={setSearchParams} query={searchParams} />
      </Row>
      <Row className=' row-sm'>
        <Col lg={12}>
          <Card className='custom-card'>
            <Card.Header>
              <Col xs={6} md={11}>
                <h3 className='card-title mb-1'>{tSideBar('challenges')} </h3>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    navigate('create')
                  }}
                >
                  {tGeneral('createChallenge')}
                </Button>
              </Col>
            </Card.Header>
            <Card.Body>
              <div className='table-responsive'>
                <Table className='table table-bordered text-nowrap text-md-nowrap mg-b-0'>
                  <thead>
                    <tr className='text-center'>
                      <th>{tGeneral('name')}</th>
                      <th>{tGeneral('nameAr')}</th>
                      <th>{tGeneral('description')}</th>
                      <th>{tGeneral('forWho')}</th>
                      <th>{tGeneral('image')}</th>
                      <th>{tGeneral('action')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {challenges?.data?.length > 0 &&
                      challenges?.data.map(challenge => (
                        <ChallengesTable
                          key={challenge.id}
                          challenge={challenge}
                          refetch={refetch}
                        />
                      ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            <Pagination
              setQuery={setSearchParams}
              numPages={Math.ceil(challenges?.count / PAGESIZE)}
              query={searchParams}
            />
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default Challenges
